import type Alpine from 'alpinejs';

import {loadAssets, type AssetDescriptor} from '../../assets/bridge';

type FragmentAlpine = Pick<Alpine.Alpine, 'initTree'> & Partial<Pick<Alpine.Alpine, 'destroyTree'>>;

type ReplaceFragmentOptions = {
    assets?: AssetDescriptor[];
    shouldReplace?: () => boolean;
};

const replaceFragmentChildrenNow = (
    AlpineInstance: FragmentAlpine,
    target: Element,
    html: string,
): void => {
    Array.from(target.children).forEach((element) => {
        if (element instanceof HTMLElement) AlpineInstance.destroyTree?.(element);
    });

    const template = document.createElement('template');
    template.innerHTML = html;
    const inserted = Array.from(template.content.children)
        .filter((element): element is HTMLElement => element instanceof HTMLElement);
    target.replaceChildren(template.content);
    inserted.forEach((element) => AlpineInstance.initTree(element));
    if (inserted.length === 0 && html.trim()) AlpineInstance.initTree(target as HTMLElement);
};

const replaceFragmentChildren = async (
    AlpineInstance: FragmentAlpine,
    target: Element,
    html: string,
    options: ReplaceFragmentOptions = {},
): Promise<boolean> => {
    if (options.assets?.length) {
        await loadAssets(options.assets, AlpineInstance as Alpine.Alpine);
    }
    if (options.shouldReplace && !options.shouldReplace()) return false;
    replaceFragmentChildrenNow(AlpineInstance, target, html);
    return true;
};

export {
    replaceFragmentChildren,
    replaceFragmentChildrenNow,
};
export type {
    FragmentAlpine,
    ReplaceFragmentOptions,
};
